import { Component, Input, OnInit, NgZone } from '@angular/core';
import { EsimActivationCodeForDevicesComponent } from '../esim-activation-code-for-devices/esim-activation-code-for-devices.component';
import { ModalController } from '@ionic/angular';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { AppCmsUrlsInitializationService } from 'src/app/services/app-cms-urls-initialization.service';
import { ApplicationInitializationService } from 'src/app/services/application-initialization.service';
import { CmsContentService } from 'src/app/services/cms-content.service';
import { GoogleAnalyticsService } from 'src/app/services/google-analytics.service';
import { EsimActivateCmsComponent } from '../esim-activate-cms/esim-activate-cms.component';
@Component({
  selector: 'app-esim-success-order',
  templateUrl: './esim-success-order.component.html',
  styleUrls: ['./esim-success-order.component.scss']
})
export class EsimSuccessOrderComponent implements OnInit {
  @Input() email: any;
  @Input() checkouteSimData: any;
  transactionId: any;
  activationCode: any;
  applewatchsuccess: boolean = false;
  ENV: any;
  installOnDevice: boolean = false;
  eSimInstalatiOnDeviceSuccess: boolean = false;
  eSimInstalatiOnDeviceError: boolean = false;
  nodes:any[]=[];
  constructor(private modalController: ModalController, private UTS: UtilitiesService, private ngZone: NgZone,private GAS:GoogleAnalyticsService) { }

  ngOnInit(): void {
    this.ENV = localStorage.getItem('ENV');
    window['esimActivationSuccessCompRef'] = {
      component: this,
      zone: this.ngZone,
      getEsimAllowedFunction: () => this.getEsimAllowed(),
      loadEsimAllowedErrorFunc: () => this.getEsimAllowedError(),
      deviceInstalationFunction: () => this.deviceInstalation(),
      deviceInstalationErrorFunc: () => this.deviceInstalationError()
    };
    if (this.checkouteSimData) {
      this.transactionId = this.checkouteSimData?.orderId;
      if (this.checkouteSimData) {
        if(this.checkouteSimData?.smdpAddress && this.checkouteSimData?.matchingId){
          this.activationCode = this.checkouteSimData ? "LPA:" + "1$" + this.checkouteSimData?.smdpAddress + "$" + this.checkouteSimData?.matchingId : ""
        }else{
          this.GAS.postpaidEsimInstall('postpaid_esim_install_success','eSimactivation Continue',this.activationCode);
        }
      }
    }
    setTimeout(() => {
      this.CheckingEligibility();
    }, 1000);
    localStorage.removeItem('SelectedSimData');
    sessionStorage.removeItem('SelectedSimData');
  }

  async openBottomSheet(component: any, data?: any, classes = 'verification-modal modal-fullscreen') {
    const modal = await this.modalController.create({
      component: component,
      showBackdrop: true,
      componentProps: { devictypes: data, checkouteSimData: this.checkouteSimData },
      // mode: "ios",
      cssClass: classes,
    });
    return await modal.present();
  }

  public openActivationCodeModal(devictypes) {
    if(this.eSimInstalatiOnDeviceError){
      this.eSimInstalatiOnDeviceError = false
    }
    var active = "Activate Manually" + " "+ devictypes;
    if (devictypes == 'Apple' || devictypes == 'Android') {
      this.GAS.VisitorLineEsimInstall('visitor_line_esim_install', active);
    }
    else{
      this.GAS.postpaidEsimInstall('postpaid_esim_install',active,this.activationCode);
    }
    this.openBottomSheet(EsimActivationCodeForDevicesComponent, devictypes, 'verification-modal eand-radius-modal eand-partail-height-screen eand-partail-height-screen-bottom-50-mobile');
  }
  gotoProduct() {
    this.GAS.postpaidEsimInstall('postpaid_esim_install_thank_you','Done',this.activationCode);
    const OS = this.UTS.getMobileOperatingSystem();
    if (this.ENV == 'mobile' && OS == 'Android') {
      (window as any).deals.goBack();

    } else if (this.ENV == 'mobile' && OS == 'iOS') {
      (window as any).webkit.messageHandlers.hybridInterface.postMessage('goBack');
    }
    else {
      let url = localStorage.getItem('cartRedirectionURL')
      if (url != null) {
        window.location.href = url;
      } else {
        window.location.href = 'https://www.eand.ae'
      }
    }
  }

  CheckingEligibility(){
      const OS = this.UTS.getMobileOperatingSystem();
      if (this.ENV == 'mobile' && OS == 'Android') {
        (window as any).deals.checkingEsimEligibility();

      } else if (this.ENV == 'mobile' && OS == 'iOS') {
        (window as any).webkit.messageHandlers.hybridInterface.postMessage('checkingEsimEligibility');
      }
  }


  getEsimAllowed() {
    this.installOnDevice = true;
    this.GAS.CJStepsFrontendLog('esim_get_esim_allowed', {shippingAddress:{} })
  }
  getEsimAllowedError() {
    this.installOnDevice = false;
    this.GAS.CJStepsFrontendLog('esim_get_esim_allowed_error', {shippingAddress:{} })
  }
  deviceInstalation() {
    this.GAS.postpaidEsimInstall('postpaid_esim_install','Install on this phone',this.activationCode);
    this.eSimInstalatiOnDeviceSuccess = true;
    this.GAS.CJStepsFrontendLog('esim_device_instalation', {shippingAddress:{} })
  }
  deviceInstalationError() {
    this.eSimInstalatiOnDeviceSuccess = false;
    this.eSimInstalatiOnDeviceError = true;
    this.GAS.CJStepsFrontendLog('esim_device_instalation_error', {shippingAddress:{} })
  }

  public openCMSModal(urlCMS) {
    if (urlCMS == 'HOW_TO_ACTIVATE_ESIM') {
      this.GAS.VisitorLineEsimInstall('visitor_line_esim_install', 'How to Activate eSim');
    }
    else {
      this.GAS.postpaidEsimInstall('postpaid_esim_install', 'Install on this phoneinfo', this.activationCode);
    }
    this.openBottomSheet(EsimActivateCmsComponent,urlCMS, 'verification-modal eand-radius-modal eand-partail-height-screen-bottom eand-partail-height-screen-bottom-70-mobile');
  }
}
